// removed by extract-text-webpack-plugin
module.exports = {"collaborator":"src-components-CollaboratorsGrid----CollaboratorsGrid-module---collaborator---1qRTt","image_bg_fill":"src-components-CollaboratorsGrid----CollaboratorsGrid-module---image_bg_fill---3KHx3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CollaboratorsGrid/CollaboratorsGrid.module.scss
// module id = 128
// module chunks = 74537795826934 162898551421021 176293843571754